import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { cashbackConstants, cashbackModels } from '..';

export const useCashbackActive = () =>
  useQuery<cashbackModels.ICashbackActive[]>({
    queryKey: [cashbackConstants.queryKeys.CASHBACK_ACTIVE],
    queryFn: async () => {
      const res = await $api.get('/v1/cashback/active');

      return res.data.data;
    },
    staleTime: Infinity
  });
